// extracted by mini-css-extract-plugin
export default {"adminPage":"admin_adminPage__Ff9MX","adminContainer":"admin_adminContainer__WxLz0","logsButton":"admin_logsButton__3+4xm"};